// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"TitleLabel_cardTitle_1VtvT","titleInfo":"TitleLabel_titleInfo_4cKHK","headerTitle":"TitleLabel_headerTitle_2khlT"};